<template>
<div style="height: 100%;margin:0 20px;overflow: hidden">
  <table class="table-show" style="color: #e1fdfd;text-align: center;margin: auto;border-collapse: collapse;border-color: #7ebbfc" border="1">
    <tr>
      <th>年龄段/人数</th>
      <th>60~70 / <strong style="color: #24bfff">{{age6}}</strong>人</th>
      <th>71~80 / <strong style="color: #24bfff">{{age7}}</strong>人</th>
      <th>81~90 / <strong style="color: #24bfff">{{age8}}</strong>人</th>
      <th>91~100 / <strong style="color: #24bfff">{{age9}}</strong>人</th>
      <th>100以上 / <strong style="color: #24bfff">{{age10}}</strong>人</th>
      <th>总人数 / <strong style="color: #24bfff">{{age}}</strong>人</th>
    </tr>
    <tr>
      <td>健康</td>
      <td><strong style="color: #24bfff">{{health6 === 0 ? 0 : Math.round((health6 / age6) * 100 * 100) / 100}}</strong>%</td>
      <td><strong style="color: #24bfff">{{health7 === 0 ? 0 : Math.round((health7 / age7) * 100 * 100) / 100}}</strong>%</td>
      <td><strong style="color: #24bfff">{{health8 === 0 ? 0 : Math.round((health8 / age8) * 100 * 100) / 100}}</strong>%</td>
      <td><strong style="color: #24bfff">{{health9 === 0 ? 0 : Math.round((health9 / age9) * 100 * 100) / 100}}</strong>%</td>
      <td><strong style="color: #24bfff">{{health10 === 0 ? 0 : Math.round((health10 / age10) * 100 * 100) / 100}}</strong>%</td>
      <td><strong style="color: #24bfff">{{health === 0 ? 0 : Math.round((health / age) * 100 * 100) / 100}}</strong>%</td>
    </tr>
    <tr>
      <td>基础疾病</td>
      <td><strong style="color: #24bfff">{{disease6 === 0 ? 0 : Math.round((disease6 / age6) * 100 * 100) / 100}}</strong>%</td>
      <td><strong style="color: #24bfff">{{disease7 === 0 ? 0 : Math.round((disease7 / age7) * 100 * 100) / 100}}</strong>%</td>
      <td><strong style="color: #24bfff">{{disease8 === 0 ? 0 : Math.round((disease8 / age8) * 100 * 100) / 100}}</strong>%</td>
      <td><strong style="color: #24bfff">{{disease9 === 0 ? 0 : Math.round((disease9 / age9) * 100 * 100) / 100}}</strong>%</td>
      <td><strong style="color: #24bfff">{{disease10 === 0 ? 0 : Math.round((disease10 / age10) * 100 * 100) / 100}}</strong>%</td>
      <td><strong style="color: #24bfff">{{disease === 0 ? 0 : Math.round((disease / age) * 100 * 100) / 100}}</strong>%</td>
    </tr>
    <tr>
      <td>重症疾病</td>
      <td><strong style="color: #24bfff">{{severeDisease6 === 0 ? 0 : Math.round((severeDisease6 / age6) * 100 * 100) / 100}}</strong>%</td>
      <td><strong style="color: #24bfff">{{severeDisease7 === 0 ? 0 : Math.round((severeDisease7 / age7) * 100 * 100) / 100}}</strong>%</td>
      <td><strong style="color: #24bfff">{{severeDisease8 === 0 ? 0 : Math.round((severeDisease8 / age8) * 100 * 100) / 100}}</strong>%</td>
      <td><strong style="color: #24bfff">{{severeDisease9 === 0 ? 0 : Math.round((severeDisease9 / age9) * 100 * 100) / 100}}</strong>%</td>
      <td><strong style="color: #24bfff">{{severeDisease10 === 0 ? 0 : Math.round((severeDisease10 / age10) * 100 * 100) / 100}}</strong>%</td>
      <td><strong style="color: #24bfff">{{severeDisease === 0 ? 0 : Math.round((severeDisease / age) * 100 * 100) / 100}}</strong>%</td>
    </tr>
  </table>
</div>
</template>

<script>
export default {
  name: 'personInfo',
  data () {
    return {
      age: 0,
      age6: 0,
      age7: 0,
      age8: 0,
      age9: 0,
      age10: 0,
      health: 0,
      health6: 0,
      health7: 0,
      health8: 0,
      health9: 0,
      health10: 0,
      disease: 0,
      disease6: 0,
      disease7: 0,
      disease8: 0,
      disease9: 0,
      disease10: 0,
      severeDisease: 0,
      severeDisease6: 0,
      severeDisease7: 0,
      severeDisease8: 0,
      severeDisease9: 0,
      severeDisease10: 0
    }
  },
  created () {
  },
  methods: {
    getPersonVal (obj) {
      let PersonTypeCount = obj.PersonTypeCount
      let PersonTypeHealthCount = obj.PersonTypeHealthCount
      let PersonTypeDiseaseCount = obj.PersonTypeDiseaseCount
      let PersonTypeSevereDiseaseCount = obj.PersonTypeSevereDiseaseCount
      for (let i = 0; i < PersonTypeCount.length; i++) {
        if (PersonTypeCount[i].age_group === '总数') {
          this.age = parseInt(PersonTypeCount[i].personcount)
        }
        if (PersonTypeCount[i].age_group === '60-70') {
          this.age6 = parseInt(PersonTypeCount[i].personcount)
        }
        if (PersonTypeCount[i].age_group === '71-80') {
          this.age7 = parseInt(PersonTypeCount[i].personcount)
        }
        if (PersonTypeCount[i].age_group === '81-90') {
          this.age8 = parseInt(PersonTypeCount[i].personcount)
        }
        if (PersonTypeCount[i].age_group === '91-100') {
          this.age9 = parseInt(PersonTypeCount[i].personcount)
        }
        if (PersonTypeCount[i].age_group === '100以上') {
          this.age10 = parseInt(PersonTypeCount[i].personcount)
        }
      }
      for (let i = 0; i < PersonTypeHealthCount.length; i++) {
        if (PersonTypeHealthCount[i].age_group === '总数') {
          this.health = parseInt(PersonTypeHealthCount[i].personcount)
        }
        if (PersonTypeHealthCount[i].age_group === '60-70') {
          this.health6 = parseInt(PersonTypeHealthCount[i].personcount)
        }
        if (PersonTypeHealthCount[i].age_group === '71-80') {
          this.health7 = parseInt(PersonTypeHealthCount[i].personcount)
        }
        if (PersonTypeHealthCount[i].age_group === '81-90') {
          this.health8 = parseInt(PersonTypeHealthCount[i].personcount)
        }
        if (PersonTypeHealthCount[i].age_group === '91-100') {
          this.health9 = parseInt(PersonTypeHealthCount[i].personcount)
        }
        if (PersonTypeHealthCount[i].age_group === '100以上') {
          this.health10 = parseInt(PersonTypeHealthCount[i].personcount)
        }
      }
      for (let i = 0; i < PersonTypeDiseaseCount.length; i++) {
        if (PersonTypeDiseaseCount[i].age_group === '总数') {
          this.disease = parseInt(PersonTypeDiseaseCount[i].personcount)
        }
        if (PersonTypeDiseaseCount[i].age_group === '60-70') {
          this.disease6 = parseInt(PersonTypeDiseaseCount[i].personcount)
        }
        if (PersonTypeDiseaseCount[i].age_group === '71-80') {
          this.disease7 = parseInt(PersonTypeDiseaseCount[i].personcount)
        }
        if (PersonTypeDiseaseCount[i].age_group === '81-90') {
          this.disease8 = parseInt(PersonTypeDiseaseCount[i].personcount)
        }
        if (PersonTypeDiseaseCount[i].age_group === '91-100') {
          this.disease9 = parseInt(PersonTypeDiseaseCount[i].personcount)
        }
        if (PersonTypeDiseaseCount[i].age_group === '100以上') {
          this.disease10 = parseInt(PersonTypeDiseaseCount[i].personcount)
        }
      }
      for (let i = 0; i < PersonTypeSevereDiseaseCount.length; i++) {
        if (PersonTypeSevereDiseaseCount[i].age_group === '总数') {
          this.severeDisease = parseInt(PersonTypeSevereDiseaseCount[i].personcount)
        }
        if (PersonTypeSevereDiseaseCount[i] && PersonTypeSevereDiseaseCount[i].age_group === '60-70') {
          this.severeDisease6 = parseInt(PersonTypeSevereDiseaseCount[i].personcount)
        }
        if (PersonTypeSevereDiseaseCount[i] && PersonTypeSevereDiseaseCount[i].age_group === '71-80') {
          this.severeDisease7 = parseInt(PersonTypeSevereDiseaseCount[i].personcount)
        }
        if (PersonTypeSevereDiseaseCount[i] && PersonTypeSevereDiseaseCount[i].age_group === '81-90') {
          this.severeDisease8 = parseInt(PersonTypeSevereDiseaseCount[i].personcount)
        }
        if (PersonTypeSevereDiseaseCount[i] && PersonTypeSevereDiseaseCount[i].age_group === '91-100') {
          this.severeDisease9 = parseInt(PersonTypeSevereDiseaseCount[i].personcount)
        }
        if (PersonTypeSevereDiseaseCount[i] && PersonTypeSevereDiseaseCount[i].age_group === '100以上') {
          this.severeDisease10 = parseInt(PersonTypeSevereDiseaseCount[i].personcount)
        }
      }
    }
  }
}
</script>

<style scoped>
.table-show th {
  font-size: 12px;
  width: 150px;
  height: 24px;
}
.table-show td {
  font-size: 12px;
  height: 24px;
}
.table-show strong{
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitoring/weiNingComponents/personInfo.vue